import React, { useEffect } from 'react';
import { useLocation } from 'react-router';

const Loader = () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    const location = useLocation();

    useEffect(() => {
        let loader = document.querySelector('.loader');
        loader.classList.add('active');

        var html = document.querySelector('html');
        let loading = html.classList.contains('is-preload');

        let menu = document.querySelector('.orb-big-menu .orb-photo-frame');
        menu.classList.remove('orb-active');
        if (!loading && location.pathname === '/') {
            setTimeout(ready, 200);
        } else {
            setTimeout(ready, 2000);
        }
    }, [location]);

    const ready = () => {
        var html = document.querySelector('html');
        html.classList.remove('is-preload');

        let photo = document.querySelector(
            '.orb-photo-frame.orb-obj-1.img-home'
        );

        if (photo !== null && !photo.classList.contains('orb-active')) {
            photo.classList.add('orb-active');
        }

        let uls = document.querySelectorAll('.orb-fs-menu .orb-has-children a');
        uls.forEach((ul) => {
            if (
                ul.classList.contains('orb-current') &&
                ul.nextSibling !== null
            ) {
                ul.nextSibling.classList.add('orb-active');
            }
        });
    };

    return (
        <div className="loader-frame">
            <div className="loader">
                <div className="deco-1">
                    <div className="prog"></div>
                </div>
                <div className="deco-2">
                    <div className="spiner"></div>
                </div>
            </div>
        </div>
    );
};

export default Loader;
